<template>
    <div>
        <title-header title="Palavra do Presidente"></title-header>
        <div class="content">
            <header>
                <div class="logo"></div>
                <div class="header-text">
                    <h1>Amauri Sérgio Mortágua</h1>
                    <h2>Presidente</h2>
                </div>
            </header>
            <comments-list v-for="(comment, index) in comments"
                           :key="index"
                           :title="comment.titulo"
                           :text="comment.noticia"
                           :date="comment.data_noticia"
                           :path="'text-presidente/'+comment.id"
                           categoria="Palavra do Presidente"
            ></comments-list>
        </div>
        <div class="tabs">
            <button class="arrow" @click="previous"><</button>
            <button v-for="page in pages"
                    v-if="Math.abs(page - active) < 3 || page === lastPage || page === 1"
                    :key="page"
                    class="tab"
                    @click="onPageChange(page); active = page"
                    :class="{'bg-primary':page === active,
                    last: (page === lastPage && Math.abs(page - active) > 3),
                    first:(page === 1 && Math.abs(page - active) > 3)}"
            >
                {{ page }}
            </button>
            <button class="arrow" @click="next">></button>
        </div>
    </div>

</template>

<script>
import TitleHeader from '../../../../components/title/title'
import CommentsList from "../components/comments-list";

import axios from 'axios';

export default {
    name: "palavra-presidente",
    components: {
        CommentsList,
        TitleHeader,
    },
    data() {
        return {
            comments: [],
            pages: [],
            active: 1,
            lastPage: 0,
        };
    },
    methods: {
        getComments() {
            axios.get('get-palavra-presidente')
                .then(res => {
                    this.comments = res.data.noticia.data
                    this.pages = res.data.noticia.last_page
                    this.lastPage = res.data.noticia.last_page
                })
        },
        onPageChange(index) {
            axios.get('get-palavra-presidente?page=' + index)
                .then(res => {
                    this.comments = res.data.noticia.data
                })
        },
        next() {
            if(this.active < this.lastPage) {
                this.onPageChange(this.active + 1)
                this.active += 1
            }
        },
        previous() {
            if(this.active > 1) {
                this.onPageChange(this.active - 1)
                this.active -= 1
            }
        }
    },
    created() {
        this.getComments()
    }
}
</script>

<style scoped lang="scss">
.content {
    max-width: 1280px;
    @apply px-8 mx-auto;

    header {
        @apply grid grid-cols-1 py-8 border-light-gray border-b-2;
        .logo {
            @apply rounded-lg mx-auto;
            height: 200px;
            width: 200px;
            background: url("../../../../../img/AMAURI_SERGIO_MORTAGUA.jpeg") no-repeat center top;
            background-size: cover;
        }
        .header-text {
            h1 { @apply font-semibold py-2 text-center; }
            h2 { @apply font-medium py-2 text-center; }
        }

        @media(min-width: 640px) {
            @apply flex items-center;
            .logo {
                @apply rounded-lg mx-0 mr-10;
                height: 200px;
                width: 200px;
                background: url("../../../../../img/AMAURI_SERGIO_MORTAGUA.jpeg") no-repeat center top;
                background-size: cover;
            }
            .header-text {
                h1 { @apply text-left; }
                h2 { @apply text-left; }
            }
        }
    }
}
.tabs {
    @apply mx-auto text-center my-12;
    .tab {
        @apply px-2 rounded-md mx-1 text-base-gray;
        border: 0.5px solid #8e8e8e;
        @media(min-width: 640px) {
            @apply rounded-lg mr-3 py-1 px-3 font-medium text-xl text-base-gray;
            border: 1px solid #8e8e8e;
        }
    }
    .tab:hover{
        @apply bg-primary font-medium text-white outline-none border-primary;
    }
    .tab:focus {
        @apply text-white outline-none;
    }
    .tab.first::after {
        content:'...'
    }

    .tab.last::before {
        content:'...'
    }
    .arrow {
        @apply py-1 font-medium text-base text-base-gray;
        @media(min-width: 640px) {
            @apply mr-3 py-1 px-3 font-medium text-xl text-base-gray;
        }
    }
    .arrow:focus {
        @apply outline-none;
    }
}
</style>
